import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendExternalSignupInvite,
  BackendMutationCreateExternalSignupArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation CreateExternalSignup($email: String!, $trackingPayload: JSON!, $source: String!) {
    createExternalSignup(email: $email, trackingPayload: $trackingPayload, source: $source) {
      email
    }
  }
`;

type Variables = BackendMutationCreateExternalSignupArgs;
type Result = BackendExternalSignupInvite;

export const createExternalSignup = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
